import './App.css';
import { useEffect, useState } from 'react';

var selectedCategory = 0;
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

  // get service domain url from env variable named KC_service and use in api calls as needed
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; 
  console.log(KC_SERVICE);


function Component_CategoryList() { 
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(1);
      try {
        const response = await fetch(KC_SERVICE + '/category_getChildList', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            selectedCategory: selectedCategory
          })
        });
        const { Categories } = await response.json();
        setData(Categories);
        console.log(Categories);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(2);
      }
    };

    fetchData();
  }, []);

  const handleSelect = (category) => {
    selectedCategory = category;
    window.location.href = window.location.pathname + "?pageName=Category&CategoryName=" + category + "&userid=" + currentuserid;
    return;
  };

  function navigateToQuestions(){
    //alert('navigating..')
    window.location.href = window.location.pathname + "?pageName=Question&CategoryName=" + selectedCategory + "&userid=" + currentuserid;
    return;
  }

  return (
    <div style={{ padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '1.5em', fontWeight: 'bold' }}>
      <h3 style={{ color: 'blue', textAlign: 'center' }}>Select Category</h3>
      {selectedCategory !== 0 && (
        <button
          style={{
            marginBottom: '20px',
            background: 'blue',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            fontSize: '1.2em',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={() => {
            window.location.href = window.location.pathname + "?pageName=Category&userid=" + currentuserid;
          }}
        >
          <span style={{ marginRight: '8px', fontSize: '1.0em' }}>↑</span> 
        </button>
      )}
      {data.length > 0 ? (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {data.map((item, index) => {
            const isClickable = !item.CategoryName.includes('(Coming soon)');
            return (
              <li
                key={index}
                style={{
                  marginBottom: '10px',
                  border: '1px solid blue',
                  padding: '10px',
                  borderRadius: '4px',
                  backgroundColor: 'blue',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: isClickable ? 'pointer' : 'default'
                }}
                onClick={isClickable ? () => handleSelect(item.id) : undefined}
              >
                <span style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                  {item.CategoryName}
                </span>
                {isClickable && (
                  <button
                    style={{
                      marginLeft: '10px',
                      fontFamily: 'Arial, sans-serif',
                      fontSize: '1.5em',
                      border: '0px solid blue',
                      fontWeight: 'bold',
                      backgroundColor: 'transparent',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      handleSelect(item.id);
                    }}
                  >
                    {'>'}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        loading === 2 && selectedCategory !== 0 && navigateToQuestions()
      )}
    </div>
  );
}

export default Component_CategoryList;